import { render } from "./ElementCTA.vue?vue&type=template&id=00379ba6&scoped=true"
import script from "./ElementCTA.vue?vue&type=script&lang=js"
export * from "./ElementCTA.vue?vue&type=script&lang=js"

import "./ElementCTA.vue?vue&type=style&index=0&id=00379ba6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00379ba6"]])

export default __exports__